"use client";

import { c as _c } from "react/compiler-runtime";
import { SegmentedControl, Tabs } from "@mantine/core";
import { Icon } from "@iconify/react";
import PureHtml from "../../custom/PureHtml";
import DefaultShippingPolicy from "@/components/policy/DefaultShippingPolicy";
import DefaultRefundPolicy from "@/components/policy/DefaultRefundPolicy";
import ReviewSection from "./ReviewSection";
import { useState } from "react";
export default function ProductInfoTabs(t0) {
  const $ = _c(26);
  const {
    product,
    shippingPolicyHtml,
    refundPolicyHtml
  } = t0;
  const [value, setValue] = useState("description");
  const t1 = `${product?.title} `;
  let t2;
  if ($[0] !== t1) {
    t2 = <h2 className="text-xl lg:text-2xl"><span className="hidden">{t1}</span>Product Information</h2>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [{
      label: "Description",
      value: "description"
    }, {
      label: "Shipping",
      value: "shipping"
    }, {
      label: "Refund",
      value: "refund"
    }, {
      label: "Reviews",
      value: "reviews"
    }];
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== value) {
    t4 = <SegmentedControl value={value} onChange={setValue} fullWidth={true} autoContrast={true} withItemsBorders={true} radius="md" size="md" bg="gray.1" data={t3} color="var(--color-primary)" transitionDuration={500} transitionTimingFunction="linear" />;
    $[3] = value;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== product?.body_html || $[6] !== value) {
    t5 = value === "description" && <div className="p-2 bg-white shadow"><PureHtml html={product?.body_html} /></div>;
    $[5] = product?.body_html;
    $[6] = value;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== shippingPolicyHtml || $[9] !== value) {
    t6 = value === "shipping" && <div className="p-2 bg-white shadow">{shippingPolicyHtml ? <PureHtml html={shippingPolicyHtml} /> : <DefaultShippingPolicy />}</div>;
    $[8] = shippingPolicyHtml;
    $[9] = value;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== refundPolicyHtml || $[12] !== value) {
    t7 = value === "refund" && <div className="p-2 bg-white shadow">{refundPolicyHtml ? <PureHtml html={refundPolicyHtml} /> : <DefaultRefundPolicy />}</div>;
    $[11] = refundPolicyHtml;
    $[12] = value;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== product || $[15] !== value) {
    t8 = value === "reviews" && <div className="p-0"><ReviewSection product={product} /></div>;
    $[14] = product;
    $[15] = value;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t5 || $[18] !== t6 || $[19] !== t7 || $[20] !== t8) {
    t9 = <div className="rounded-md mt-2">{t5}{t6}{t7}{t8}</div>;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t2 || $[23] !== t4 || $[24] !== t9) {
    t10 = <div id="description">{t2}{t4}{t9}</div>;
    $[22] = t2;
    $[23] = t4;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  return t10;
}